import { FeatureToggleClientService } from 'feature-toggle-client';
const IsBlipPaymentsEnabled = 'is-blip-commerce-enabled';
export class BlipPaymentsFeatures {
    static IsBlipPaymentsEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(IsBlipPaymentsEnabled, false);
    }
}
